import { Switch, SwitchProps } from "@justhome/react-ui";
import { PropsWithChildren } from "react";
import { Control, Controller, FieldValues, Path } from "react-hook-form";

interface ControlledSwitchProps<T extends FieldValues>
  extends Partial<SwitchProps> {
  name: Path<T>;
  control: Control<T>;
}

const ControlledSwitch = <T extends FieldValues>({
  control,
  children,
  name,
  ...props
}: PropsWithChildren<ControlledSwitchProps<T>>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        return <Switch {...field} {...props} checked={!!field.value} />;
      }}
    />
  );
};

export default ControlledSwitch;
